import axios from "axios";
import store from "../store";

/* eslint-disable no-unused-vars */
// const host = "https://localhost:44366";
// const host = "https://localhost:5001";

// 220503 sunhye host api 환경변수 처리
// const host = "https://api.richgo.ai";
const host = process.env.VUE_APP_HOST

//const host = "http://docker-registry.richgo.ai";
const login_naver_url = "/api/oauth/naver";
const login_google_url = "/api/oauth/google";
const login_kakao_url = "/api/oauth/kakao";
const login_facebook_url = "/api/oauth/facebook";
const profile_url = "/api/users/profile";
const register_url = "/api/users/register";
const withdraw_url = "/api/users/withdraw";
const updateProfile_url = "/api/users/update";
const accessToken_url = "/api/users/access-token";
const getReportPrivate_url = "/api/report";
// tableau server
const tableauTicket_url = "/api/tableauticket";
// payment
const payment_url = "/api/payment";
const products_url = "/api/product";
const subscriptions_url = "/api/users/subscriptions";
const area_url = "/api/data/area";

const login_url_obj = {
  naver: login_naver_url,
  kakao: login_kakao_url,
  facebook: login_facebook_url,
  google: login_google_url,
};

const hdecBusinessResultType = {
  0: "성공",
  1: "존재하지 않는 사업지입니다.",
}

function getConfig(token) {
  return {
    headers: {
      Authorization: `bearer ${token}`,
      // 일단은 별도의 캐싱을 하지 않는다. (IE 때문)
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  };
}
// http://vuejs.kr/update/2017/01/04/http-request-with-axios/
// IE에서 적용 안 된다는 말이 있음
export const api = {
  methods: {
    async getAccessToken() {
      const config = getConfig(store.state.refreshToken);
      const url = `${host}${accessToken_url}`;

      try {
        const response = await axios.get(url, config);
        return response.data;
      } catch (error) {
        if (error.response.status === 409) {
          alert("회원님의 아이디로 다른 환경에서의 로그인이 확인되었습니다.");
          return 409;
        } else {
          console.error(
            "exception occurred while executing getAccessTokenApi",
            error
          );
        }
        return null;
      }
    },
    async signupApi(registerToken, data) {
      const config = getConfig(registerToken);
      const url = `${host}${register_url}`;

      try {
        const response = await axios.post(url, data, config);
        return response.data;
      } catch (error) {
        console.error("exception occurred while executing signupApi", error);
        return null;
      }
    },
    async withdrawApi() {
      await store.dispatch("ensureAccessToken");

      const config = getConfig(store.state.accessToken);
      const url = `${host}${withdraw_url}`;
      try {
        const response = await axios.delete(url, config);
        return response.status === 200;
      } catch (error) {
        console.error(
          "exception occurred while executing getProfileApi",
          error
        );
        return null;
      }
    },
    async getProfileApi() {
      await store.dispatch("ensureAccessToken");

      const config = getConfig(store.state.accessToken);
      const url = `${host}${profile_url}`;

      try {
        const response = await axios.get(url, config);
        return response.data;
      } catch (error) {
        console.error(
          "exception occurred while executing getProfileApi",
          error
        );
        return null;
      }
    },
    async updateProfileApi(data) {
      await store.dispatch("ensureAccessToken");
      const config = getConfig(store.state.accessToken);
      const url = `${host}${updateProfile_url}`;

      try {
        const response = await axios.put(url, data, config);
        return response;
      } catch (error) {
        console.error(
          "exception occurred while executing updateProfileApi",
          error
        );
        return null;
      }
    },
    async loginApi(providerName) {
      if (login_url_obj.hasOwnProperty(providerName) === false) {
        console.error("존재하지 않는 로그인입니다.");
        return null;
      }

      const url = `${host}${login_url_obj[providerName]}`;

      try {
        const response = await axios.get(url);
        return response.data;
      } catch (error) {
        console.error("exception occurred while executing loginApi", error);
        return null;
      }
    },
    async loginIdPassword(email, password, providerName) {

      const url = `${host}/api/users/login-password`;
      try {
        const response = await axios.post(url, {
          'Email': email,
          'Password': password,
          'ProviderName': providerName
        });
        return response;

      } catch (error) {
        console.error("exception occurred while execugin loginIdPasswordApi", error);
      }
    },
    async changePasswordApi(oldPassword, newPassword) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      const config = getConfig(store.state.accessToken);
      const url = `${host}/api/users/change-password`;
      try {
        return await axios.post(url, {
          password: oldPassword,
          newPassword: newPassword
        }, config);
      } catch (error) {
        return false;
      }
    },
    async getTableauTicketApi(tableauId, isCorp) {
      await store.dispatch("ensureAccessToken");

      const config = getConfig(store.state.accessToken);
      const url = `${host}${tableauTicket_url}?id=${tableauId}&isCorp=${isCorp}`;

      try {
        const response = await axios.get(url, config);
        return {
          isAllowed: true,
          ticket: response.data,
        };
      } catch (error) {
        if (error.response.status === 403) {
          return {
            isAllowed: false,
            ticket: null,
          };
        } else {
          console.error(
            "exception occurred while executing getTableauTicketApi",
            error
          );
          return null;
        }
      }
    },
    async requestPaymentApi(productId) {
      await store.dispatch("ensureAccessToken");

      const config = getConfig(store.state.accessToken);
      const url = `${host}${payment_url}`;

      try {
        const response = await axios.post(url, { productId }, config);
        return response.data;
      } catch (error) {
        alert(error.response.data)
        console.error(
          "exception occurred while executing requestPaymentApi",
          error
        );
        return null;
      }
    },
    async refreshPaymentApi(transactionId) {
      await store.dispatch("ensureAccessToken");
      const url = `${host}/api/payment/${transactionId}/refresh`;

      try {
        const response = await axios.get(
          url,
          getConfig(store.state.accessToken)
        );
        return response;
      } catch (error) {
        console.error(
          "exception occurred while executing refreshPaymentApi",
          error
        );
        return false;
      }
    },
    async notificationPaymentApi(transactionId) {
      await store.dispatch("ensureAccessToken");
      const url = `${host}/api/payment/${transactionId}/notification`;

      try {
        await axios.post(url, null, getConfig(store.state.accessToken));
        return true;
      } catch (error) {
        console.error(
          "exception occurred while executing notificationPaymentApi",
          error
        );
        return null;
      }
    },
    async getPaymentStateApi(transactionId) {
      await store.dispatch("ensureAccessToken");
      const url = `${host}${payment_url}/${transactionId}`;

      try {
        const response = await axios.get(
          url,
          getConfig(store.state.accessToken)
        );
        return response.data;
      } catch (error) {
        console.error(
          "exception occurred while executing getPaymentStateApi",
          error
        );
        return null;
      }
    },
    async getPaymentHistoryApi() {
      await store.dispatch("ensureAccessToken");
      const url = `${host}${payment_url}`;

      try {
        const response = await axios.get(
          url,
          getConfig(store.state.accessToken)
        );
        return response.data;
      } catch (error) {
        console.error(
          "exception occurred while executing getPaymentHistoryApi",
          error
        );
        return null;
      }
    },
    async getProductsApi() {
      await store.dispatch("ensureAccessToken");
      const url = `${host}${products_url}`;

      return await axios.get(url, getConfig(store.state.accessToken));
    },
    async getSubscriptionsApi() {
      await store.dispatch("ensureAccessToken");
      const url = `${host}${subscriptions_url}`;

      try {
        const response = await axios.get(
          url,
          getConfig(store.state.accessToken)
        );
        return response.data;
      } catch (error) {
        console.error(
          "exception occurred while executing getSubscriptionsApi",
          error
        );
      }
    },
    async getReportPrivateUrlApi(category, file) {
      await store.dispatch("ensureAccessToken");
      const url = `${host}${getReportPrivate_url}/category/${category}/file/${file}`;

      try {
        const response = await axios.get(
          url,
          getConfig(store.state.accessToken)
        );
        return {
          isAllowed: true,
          url: response.data,
          status: response.status,
        };
      } catch (error) {
        if (error.response.status === 403) {
          return {
            isAllowed: false,
            url: null,
            status: error.response.status,
          };
        } else {
          console.error(
            "exception occurred while executing getReportPrivateUrlApi",
            error
          );
          return null;
        }
      }
    },
    async getAreaV2Api(bjdCode) {
      // 환경 분리 필요
      const url = `https://api-m.richgo.ai/common/GetBjdAreaWithName/${bjdCode}?withPopulation=true`;

      try {
        const response = await axios.get(url);

        // 인구수를 표시해준다.
        let formatNumber = (num) => {
          if (num > 10000) {
            return `${Math.floor(num / 10000)}만`;
          } else if (num > 1000) {
            return `${Math.floor(num / 1000)}천`;
          } else {
            return `${num}`;
          }
        }

        response.data.result.sublist.forEach(item => {
          item.name = `${item.name} (${formatNumber(item.population)})`;
        })
        return response.data.result;
      } catch (error) {
        console.error("exception occurred while executing getAreaV2Api", error);
      }
    },
    async getMenuApi(category) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      const url = `${host}/api/contents/${category}/menu`;
      try {
        const response = await axios.get(url, getConfig(store.state.accessToken));
        return response.data.result;
      } catch (error) {
        console.error('exception occurred while executing getMenuApi', error);
      }
    },
    async useCoupon(couponId) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      const url = `${host}/api/users/coupon/${couponId}`;
      try {
        const response = await axios.put(url, null, getConfig(store.state.accessToken));
        return response.data;
      } catch (error) {
        console.error('exception occurred while using coupon');
      }
    },
    async registerRichgoLink(richgoUserId) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      const url = `${host}/api/users/richgo-user-link/${richgoUserId}`;
      try {
        const response = await axios.post(url, null, getConfig(store.state.accessToken));
        return response.data;
      } catch (error) {
        console.error('exception occurred while registering richgo link');
      }
    },
    async getRichgoLink() {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      const url = `${host}/api/users/richgo-user-link`;
      try {
        const response = await axios.get(url, getConfig(store.state.accessToken));
        return response.data;
      } catch (error) {
        console.error('exception occurred while getting richgo link');
      }

    },
    async unregisterRichgoLink() {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      const url = `${host}/api/users/richgo-user-link`;
      try {
        const response = await axios.delete(url, getConfig(store.state.accessToken));
        return response.data;
      } catch (error) {
        console.error('exception occurred while unregistering richgo link');
      }
    },
    async kakaoLocationApi(address) {
      let key = "5fb666bbfe1cb5ccd3ee9cf866623146";
      let url = `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURI(address)}`;
      try {
        let response = await axios.get(url, {
          headers: {
            Authorization: `KakaoAK ${key}`
          }
        });
        console.log(JSON.stringify(response.data))
        return response.data;
      } catch (error) {
        console.error("exception occurred while getting address info");
      }
    },
    async getHdecBusinessSite(siteId) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }
      try {
        const url = `${host}/api/b2b/hdec/business-site/${siteId}`;
        const response = await axios.get(url, getConfig(store.state.accessToken));
        return response.data.result;
      } catch (error) {
        console.error("exception occurred while getting hdec business site");
      }
    },
    // convertHdecBusinessAddressInfoToEntity(requestString, addressInfo, bjdCode, inputInfo) {
    //   let address = addressInfo.address;
    //   let road = addressInfo.address_road;
    //
    //   let obj = {
    //     ...inputInfo,
    //     ...addressInfo,
    //     "requested_address": requestString,
    //     "address_bjd": address ? address.address_name : null,
    //     "address_road": road ? road.address_name : null,
    //     "bjd_code": bjdCode,
    //     // "sd": "인천",
    //     // "sgg": "미추홀구",
    //     // "emd": "학익동",
    //     // "bunji_mountain": null,
    //     // "bunji_main": null,
    //     // "bunji_sub": null,
    //   }
    // },
    async createHdecBusinessSite(data) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      try {
        const url = `${host}/api/b2b/hdec/business-site`;
        const response = await axios.post(url, data, getConfig(store.state.accessToken));
        if (response.status !== 200 || response.data.result.result !== 0) {
          alert(hdecBusinessResultType[response.data.result.result]);
          return false;
        }
        alert("생성되었습니다.");
        return true;
      } catch (error) {
        console.error("exception occurred while creating business site");
        alert("에러가 발생했습니다. 개발팀에 문의해주세요. [code: 1]");
      }
    },
    async updateHdecBusinessSite(siteId, data) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      try {
        const url = `${host}/api/b2b/hdec/business-site/${siteId}`;
        const response = await axios.put(url, data, getConfig(store.state.accessToken));
        if (response.status !== 200 || response.data.result.result !== 0) {
          alert(hdecBusinessResultType[response.data.result.result]);
          return false;
        }
        alert("수정 되었습니다.");
        return true;
      } catch (error) {
        console.error("exception occurred while updating business site");
        alert("에러가 발생했습니다. 개발팀에 문의해주세요. [code: 2]");
      }
    },
    async deleteHdecBusinessSite(siteId) {
      if (store.state.isLoggedin) {
        await store.dispatch("ensureAccessToken");
      }

      try {
        const url = `${host}/api/b2b/hdec/business-site/${siteId}`;
        const response = await axios.delete(url, getConfig(store.state.accessToken));
        if (response.status !== 200 || response.data.result.result !== 0) {
          alert(hdecBusinessResultType[response.data.result.result]);
          return false;
        }
        alert("삭제되었습니다.");
        return true;
      } catch (error) {
        console.error("exception occurred while getting business site");
        alert("에러가 발생했습니다. 개발팀에 문의해주세요. [code: 3]");
      }
      // login_url_obj.hasOwnProperty(providerName)
    }
  },
};
